import { Observable } from "rxjs";
import { InjectionToken } from "@angular/core";
import { NotificationSearchModel } from "../models";
import { BaseResponseModel } from "../models/base-response.model";

export const COMMON_SERVICE = new InjectionToken("common service...")
export interface CommonInterface {
    getCountryList(): Observable<BaseResponseModel<any>>;
    getStateList(countryId: string): Observable<BaseResponseModel<any>>;
    getStoreList(): Observable<BaseResponseModel<any>>;
    changeFormatUtcToIst<T>(formateData: BaseResponseModel<T>);
    notificationMarkAsRead(notificationId: number): Observable<BaseResponseModel<any>>;
    getNotificationList(searchModel: NotificationSearchModel): Observable<BaseResponseModel<any>>;
    getNotificationsUnreadCount(): Observable<BaseResponseModel<any>>;
}